class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems?.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartSubscribeButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      const itemQty =
        event.currentTarget
          .closest("cart-drawer-items")
          ?.querySelector(".quantity__input")?.value || 1;
      cartItems?.updateItemSellingPlan(
        event,
        event.currentTarget.dataset.itemKey,
        event.currentTarget.dataset.sellingId,
        itemQty
      );
    });
  }
}
customElements.define("cart-subscribe-button", CartSubscribeButton);

/* =============================================
   FREE GIFT — INSTANT UPDATE FIXED
   ============================================= */
/* =============================================
   FREE GIFT — FINAL VERSION (INSTANT + SMART RELOAD ON EMPTY)
   ============================================= */
let isProcessingGift = false;
let hasReloadedOnEmpty = false; // ← Prevents multiple reloads

function lockFreeGiftQty() {
  const giftId = window.theme?.freeGift?.variantId;
  if (!giftId) return;

  document.querySelectorAll(`[data-variant-id="${giftId}"]`).forEach((row) => {
    const input = row.querySelector(".quantity__input");
    if (input) {
      input.readOnly = true;
      input.value = 1;
    }
    row
      .querySelectorAll('button[name="plus"], button[name="minus"]')
      .forEach((btn) => (btn.style.display = "none"));
    const removeBtn = row.querySelector(
      'cart-remove-button, [aria-label*="Remove"]'
    );
    if (removeBtn) removeBtn.style.display = "block";
  });
}

// PREVENT DIRECT ACCESS TO FREE GIFT PRODUCT PAGE
function blockFreeGiftProductPage() {
  const giftId = window.theme?.freeGift?.variantId;
  if (!giftId) return;

  // If we're currently on the free gift product page → redirect away instantly
  if (Shopify?.routes?.root) {
    const currentProductId = window.meta?.product?.id;
    const currentVariantId = window.meta?.product?.variants?.[0]?.id || window.meta?.product?.selected_or_first_available_variant?.id;

    if (currentProductId && (currentVariantId == giftId || currentProductId == giftId)) {
      // Redirect to homepage (or collection, or "/products" – whatever you prefer)
      window.location.href = "/"; // ← change to "/collections/all" or any URL you want
      return;
    }
  }

  // Also block direct URL access via history (in case someone pastes the URL)
  if (performance.navigation.type === 0) { // normal navigation (not reload)
    const path = window.location.pathname;
    if (path.includes(`/products/`) && window.meta?.product) {
      const variantId = window.meta.product.variants?.[0]?.id || window.meta.product.selected_or_first_available_variant?.id;
      if (variantId == giftId) {
        window.location.href = "/";
      }
    }
  }
}

// Run on page load
document.addEventListener("DOMContentLoaded", blockFreeGiftProductPage);
// Also run when Shopify finishes loading product data (covers SPA navigation)
window.addEventListener("load", blockFreeGiftProductPage);

async function handleFreeGift() {
  if (isProcessingGift || !window.theme?.freeGift?.enabled) return;

  const giftId = Number(window.theme.freeGift.variantId);
  const threshold = Number(window.theme.freeGift.threshold);
  if (!giftId || giftId === 0) return;

  isProcessingGift = true;

  try {
    const cart = await fetch("/cart.js?t=" + Date.now()).then((r) => r.json());

    const totalWithoutGift = cart.items
      .filter((item) => Number(item.variant_id) !== giftId)
      .reduce((sum, item) => sum + item.line_price, 0);

    const hasGift = cart.items.some(
      (item) => Number(item.variant_id) === giftId
    );
    const shouldHaveGift = totalWithoutGift >= threshold;
    const nonGiftItems = cart.items.filter(
      (item) => Number(item.variant_id) !== giftId
    );
    const cartIsEmpty = nonGiftItems.length === 0;

    let cartChanged = false;

    // CASE 1: Cart is completely empty → clear everything + reload once
    if (cartIsEmpty && cart.items.length > 0) {
      console.log("Cart empty → clearing all + reloading once");
      await fetch("/cart/clear.js", { method: "POST" });
      cartChanged = true;

      // RELOAD ONLY ONCE when cart becomes empty
      if (!hasReloadedOnEmpty) {
        hasReloadedOnEmpty = true;

        // Instant visual feedback + reload in 100ms max
        requestAnimationFrame(() => {
          // Tiny micro-delay so the "remove" animation finishes (feels instant)
          setTimeout(() => location.reload(), 80);
        });
      }
    }
    // CASE 2: Below threshold → remove gift only
    else if (!shouldHaveGift && hasGift) {
      console.log("Below threshold → removing free gift");
      const giftItem = cart.items.find(
        (item) => Number(item.variant_id) === giftId
      );
      if (giftItem?.key) {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
        });
        if (res.ok) cartChanged = true;
      }
    }
    // CASE 3: Above threshold → add gift
    else if (shouldHaveGift && !hasGift) {
      console.log("Above threshold → adding free gift");
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }] }),
      });
      if (res.ok) cartChanged = true;
    }

    // Refresh UI instantly if changed
    if (cartChanged && !cartIsEmpty) {
      // Don't refresh if we're about to reload
      const sections =
        "cart-drawer,main-cart-items,main-cart-footer,cart-icon-bubble,cart-live-region-text";
      const data = await fetch(`/?sections=${sections}&t=${Date.now()}`).then(
        (r) => r.json()
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { sections: data },
        })
      );

      publish(PUB_SUB_EVENTS.cartUpdate, { source: "free-gift" });
    }

    // Reset flag when cart has items again
    if (!cartIsEmpty) hasReloadedOnEmpty = false;
  } catch (err) {
    console.error("Free Gift Error:", err);
  } finally {
    lockFreeGiftQty();
    isProcessingGift = false;
  }
}

/* =============================================
   INSTANT TRIGGER — NO DELAY
   ============================================= */
document.addEventListener("DOMContentLoaded", () => {
  const start = () => {
    if (!window.theme?.freeGift?.variantId) return false;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if (e.source === "free-gift") return;
      handleFreeGift(); // ← Instant call
    });

    setTimeout(handleFreeGift, 800);
    return true;
  };

  start();
  const check = setInterval(() => {
    if (start()) clearInterval(check);
  }, 200);
});

/* =============================================
   EXTRA SAFETY — run on refresh
   ============================================= */
document.addEventListener("cart:refresh", () => {
  handleFreeGift();
});
/* =============================================
   CART ITEMS CLASS (Unchanged)
   ============================================= */
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    const debouncedOnChange = debounce(
      (event) => this.onChange(event),
      ON_CHANGE_DEBOUNCE_TIMER
    );
    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.progressChange();
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") return;
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  progressChange() {
    const rewardPoints = document.querySelectorAll(".reward_point");
    const progressBar = document.querySelector("[data-progress-bar]");
    if (!rewardPoints[0] || !progressBar) return;
    const parentOffset = rewardPoints[0].parentElement.offsetLeft || 0;
    for (const point of rewardPoints) {
      const currentPrice = parseFloat(point.dataset.cartTotal);
      const currentThreshold = parseFloat(point.dataset.threshold);
      if (
        point.classList.contains("data-claimed-reward-main") &&
        currentPrice > currentThreshold
      )
        continue;
      const pointCenter = point.offsetLeft + point.offsetWidth / 2;
      const totalLeftWidth = pointCenter + parentOffset;
      const pixelWidth = (currentPrice / currentThreshold) * totalLeftWidth;
      progressBar.style.width = `${pixelWidth}px`;
      break;
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          ["cart-drawer-items", ".cart-drawer__footer"].forEach((sel) => {
            const target = document.querySelector(sel);
            const source = html.querySelector(sel);
            if (target && source) target.replaceWith(source);
          });
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          const source = html.querySelector("cart-items");
          if (source) this.innerHTML = source.innerHTML;
        });
    }
    setTimeout(lockFreeGiftQty, 50);
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((r) => r.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          if (quantityElement)
            quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        const updatedValue = parsedState.items[line - 1]?.quantity;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement?.value)
        ) {
          message =
            typeof updatedValue === "undefined"
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace(
                  "[quantity]",
                  updatedValue
                );
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          if (cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            );
          } else {
            lineItem.querySelector(`[name="${name}"]`).focus();
          }
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => this.disableLoading(line));
  }

  updateItemSellingPlan(evt, key, selling_id, qty) {
    evt.currentTarget.querySelector("span")?.style.setProperty("opacity", "0");
    evt.currentTarget
      .querySelector(".loading__spinner")
      ?.classList.remove("hidden");
    if (key && selling_id) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: key,
          quantity: qty,
          selling_plan: parseInt(selling_id),
          sections: this.getSectionsToRender().map((s) => s.section),
        }),
      })
        .then((r) => r.json())
        .then((updatedCart) => {
          const parsedState = updatedCart;
          publish(PUB_SUB_EVENTS.cartUpdate, (e) => {
            if (e.source !== "cart-items") this.onCartUpdate();
          });
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                ?.querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });
          evt.currentTarget
            .querySelector("span")
            ?.style.setProperty("opacity", "1");
          evt.currentTarget
            .querySelector(".loading__spinner")
            ?.classList.add("hidden");
        })
        .catch(console.error);
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", "true");

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    if (cartStatus) cartStatus.setAttribute("aria-hidden", "false");

    setTimeout(() => {
      if (cartStatus) cartStatus.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    if (mainCartItems) mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", "false");
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    if (mainCartItems) mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "input",
          debounce((event) => {
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({ note: event.target.value }),
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
